import { Quote } from "lucide-react";

const ITEMS = [
  {
    name: "Priya Sharma",
    city: "Jaipur, RJ",
    quote: "I run this from my kitchen. In four months I'm making ₹9,200 every month — enough to pay my daughter's tuition.",
    earn: "₹9,200 / mo",
  },
  {
    name: "Ramesh Kumar",
    city: "Patna, BR",
    quote: "Started selling in my apartment society. Zero investment risk because the wholesale rates are honest.",
    earn: "₹6,800 / mo",
  },
  {
    name: "Anita Verma",
    city: "Indore, MP",
    quote: "The team helped me set up a WhatsApp catalog. Now customers reorder every month automatically.",
    earn: "₹10,400 / mo",
  },
];

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="section-pad bg-white border-y border-[#E7E5E4]">
      <div className="container-x">
        <div className="max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#C2410C]">Real stories</div>
          <h2 className="font-display mt-3 text-3xl sm:text-5xl font-black text-[#064E3B] tracking-tight">
            People just like you, earning right now
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {ITEMS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="card-lift bg-[#FAFAF9] border border-[#E7E5E4] rounded-2xl p-7 flex flex-col"
            >
              <Quote className="h-8 w-8 text-[#F59E0B]" />
              <p className="mt-4 text-[#1C1917] leading-relaxed">{t.quote}</p>
              <div className="mt-6 pt-4 border-t border-[#E7E5E4] flex items-center justify-between">
                <div>
                  <div className="font-display font-bold text-[#064E3B]">{t.name}</div>
                  <div className="text-xs text-[#57534E]">{t.city}</div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#57534E]">
                    Earning
                  </div>
                  <div className="font-display font-black text-[#C2410C]">{t.earn}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
